import { HeartBank } from "../../../managers/HeartBank.ts";
import { Feedbacks } from "../../../managers/Feedbacks.ts";
import { render } from "lit-html";

import { analytics, performance } from "../../../firebase.ts";
import { trace, PerformanceTrace } from "firebase/performance";
import { logEvent, setUserProperties } from "firebase/analytics";

import { Modal } from "flowbite";
import type { ModalOptions, ModalInterface } from "flowbite";
import type { InstanceOptions } from "flowbite";

import template from "./sw-feedback.mjs";
import Strings from "../../../models/Strings.json";
import { LANGUAGE, HB_VAULT } from "../../global.ts";
import { SwPopup } from "../sw-popup/sw-popup.ts";
import { SwCode } from "../../sw-header/sw-code/sw-code.ts";
import { SwDonate } from "../sw-donate/sw-donate.ts";

const strings: any = Strings;

export class SwFeedback extends HTMLElement {
    private componentTrace: PerformanceTrace;
    private heartbank: HeartBank = new HeartBank();
    private manager: Feedbacks = new Feedbacks();

    private code = document.querySelector("sw-code") as SwCode;
    private popup = document.querySelector("sw-popup") as SwPopup;
    private rating: number = 0;

    private feedback: HTMLElement;
    private modal: ModalInterface;

    private form: HTMLFormElement;
    private input: HTMLTextAreaElement;
    private loginBtn: HTMLButtonElement;
    private logoutBtn: HTMLButtonElement;
    private message: HTMLParagraphElement;
    private passkeys: HTMLSpanElement;
    private settings: HTMLSpanElement;
    private hb: HTMLElement;

    constructor() {
        super();
        this.componentTrace = trace(performance, "component");
        this.componentTrace.putAttribute("view", "sw-feedback");
        this.componentTrace.start();
        render(template(null), this);

        this.feedback = this.querySelector("#sw-feedback")!;
        this.form = this.querySelector("form")!;
        this.input = this.querySelector("#sw-feedback-input")!;
        this.loginBtn = this.querySelector("#sw-login")!;
        this.logoutBtn = this.querySelector("#sw-logout")!;
        this.message = this.querySelector("#sw-feedback-message")!;
        this.passkeys = this.querySelector("#sw-feedback-passkeys")!;
        this.settings = this.querySelector("#sw-feedback-settings")!;
        this.hb = this.querySelector("#sw-feedback-hb")!;

        const modalOptions: ModalOptions = {
            placement: "center",
            backdrop: "dynamic",
            backdropClasses:
                "bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-40",
            closable: true,
            onHide: () => {
                //window.location.hash = "#";
            },
            onShow: () => {
                //this.message.textContent = strings.feedback6[LANGUAGE];
                this.message.style.color = "";
                //console.log("modal is shown");
            },
            onToggle: () => {
                //console.log("modal has been toggled");
            }
        };

        // instance options object
        const instanceOptions: InstanceOptions = {
            id: "sw-feedback",
            override: true
        };

        this.modal = new Modal(this.feedback, modalOptions, instanceOptions);
    }

    show() {
        this.modal.show();
    }

    hide() {
        this.modal.hide();
    }

    connectedCallback() {
        this.form.addEventListener("submit", this.handleSubmit.bind(this));
        this.loginBtn.addEventListener("click", this.handleLogin.bind(this));
        this.logoutBtn.addEventListener("click", this.handleLogout.bind(this));
        this.settings.addEventListener(
            "click",
            this.popup.openVault.bind(this, "humanity", false) // humanity/silver
        );
        this.passkeys.addEventListener(
            "click",
            this.popup.openVault.bind(this, "lockbox", false)
        );
        this.hb.addEventListener("click", () => {
            this.popup.openHB("", true); //TODO: add sw org link
            //this.code.show();
        });

        this.addStarListeners();
        window.addEventListener("message", (event: MessageEvent) => {
            if (event.origin === HB_VAULT)
                this.handleMessageFromPopup(event.data);
        });

        this.heartbank.addAuthStateListener3((hero) => {
            //console.log(this.isConnected);
            this.message.textContent = hero ? "" : strings.feedback10[LANGUAGE];
            this.message.style.color = "";
            render(template(hero), this);
        });

        this.componentTrace.incrementMetric("count", 1);
        this.componentTrace.stop();
    }

    private addStarListeners() {
        this.form
            .querySelectorAll<SVGElement>("svg")
            .forEach((star, index, stars) => {
                // star.addEventListener("mouseenter", () => {
                //     if (this.rating === 0) {
                //         for (let i = 0; i <= index; i++) {
                //             stars[i].style.fill = "yellow";
                //         }
                //     }
                // });

                // star.addEventListener("mouseleave", () => {
                //     if (this.rating === 0) {
                //         for (let i = 0; i <= index; i++) {
                //             stars[i].style.fill = "gray";
                //         }
                //     }
                // });

                //TODO: weird bug sometimes 5 stars don't get registered...
                star.addEventListener("click", (event: any) => {
                    const svg = event.target.parentElement as SVGElement;
                    if (svg.tagName === "svg") {
                        this.rating = parseInt(svg.id.split("-")[2]);
                        stars.forEach(
                            (s, i) =>
                                (s.style.fill =
                                    i < this.rating! ? "yellow" : "gray")
                        );
                    }
                });
            });
    }

    private async handleLogin() {
        if (!navigator.onLine) {
            alert(strings.offline[LANGUAGE]);
            return;
        }

        if (this.heartbank.hero) {
            const status = await this.heartbank.signIn2();
            this.message.textContent = status.text;
            this.message.style.color =
                status.type === "success" ? "green" : "red";
        } else this.popup.openVault("login");
    }

    private async handleLogout() {
        if (!navigator.onLine) {
            alert(strings.offline[LANGUAGE]);
            return;
        }

        this.popup.openVault("logout");
        // const status = await this.heartbank.signOut2();
        // if (status.type === "success") {
        //     this.popup.openVault("logout");
        //     //this.hide();
        //     const logout = confirm(status.text);
        //     if (logout) {
        //         this.popup.openVault("logout");
        //     } else {
        //         //window.location.hash = "#/";
        //         //window.location.reload();
        //     }
        // } else {
        //     //alert(status.text);
        // }
    }

    //TODO: later add rate limit by creating this.counter = 0; // not super effective
    // store ip address and user agent for anonymous user
    private async handleSubmit(event: Event) {
        if (!navigator.onLine) {
            alert(strings.offline[LANGUAGE]);
            return;
        }

        event.preventDefault();
        const feedback = await this.manager.createFeedback({
            deviceId: this.heartbank.getDeviceID(),
            userId: this.heartbank.user ? this.heartbank.user.uid : "",
            user: localStorage.getItem("user") || "Unknown User",
            rating: this.rating as 0 | 1 | 2 | 3 | 4 | 5,
            message: this.input.value,
            language: strings.language[LANGUAGE]
        });

        if (feedback.status === "success") {
            this.message.textContent = strings.feedback8[LANGUAGE];
            this.message.style.color = "green";
            alert(strings.feedback8[LANGUAGE]);

            this.rating = 0;
            this.form
                .querySelectorAll<SVGElement>("svg")
                .forEach((s, i) => (s.style.fill = "gray"));

            this.form.reset();
            this.modal.hide();

            const donate = document.querySelector(
                "#sw-menu-feedback"
            ) as SwDonate; //TODO: redo as flowbite component
            donate.click();
        } else {
            // alert(response.message);
            this.message.textContent = feedback.message ?? "";
            this.message.style.color = "red";
        }
    }

    private async handleMessageFromPopup(data: {
        action: string;
        [key: string]: any;
    }) {
        let status: { type: string; text: string };
        switch (data.action) {
            case "success": //TODO: change to login for all
                status = await this.heartbank.signIn(data.token);
                // if (status.type === "success") {
                //     //window.location.hash = "#/account";
                //     // re-render? should be automatic
                //     //window.location.reload();
                // } else {
                //     //window.location.hash = "#";
                //     //alert(status.text);
                // }
                this.message.textContent = status.text;
                this.message.style.color =
                    status.type === "success" ? "green" : "red";
                break;
            case "logout":
                //alert(strings.feedback13[LANGUAGE]);
                status = await this.heartbank.signOut3();
                this.message.textContent = status.text;
                this.message.style.color =
                    status.type === "success" ? "green" : "red";
                //window.location.hash = "#/";
                //window.location.reload();
                //window.setTimeout(window.location.reload, 2000); // illegal innovation by chrome
                break;
        }
    }
}
